// extracted by mini-css-extract-plugin
module.exports = {"tooltip--content":"Tooltip_tooltip--content__16JUT","tooltip--icon":"Tooltip_tooltip--icon__FVc7p"};